<template>
  <div>
    <!-- 导入按钮组件 -->
    <Upload
      :action="uploadUrl"
      :before-upload="beforeUpload"
      :on-success="handleSuccess"
      :show-upload-list="false"
      accept=".xls,.xlsx"
    >
      <Button type="primary" icon="ios-cloud-upload-outline">{{ uploadButtonText }}</Button>
    </Upload>

    <!-- 预览和确认导入的Modal组件 -->
    <Modal
      v-model="importModalVisible"
      title="导入数据预览"
      ok-text="确认导入"
      @on-ok="confirmImport"
      @on-cancel="cancelImport"
      width="60"
      :scrollable="true"
    >
      <!-- 提示 -->
      <span style="color: #999;">系统会自动过滤不合格的数据，请确保导入数据符合要求。</span>

      <!-- 数据表格 -->
      <Table :columns="previewColumns" :data="previewData" :stripe="true" no-data-text="暂无数据" no-filtered-data-text="暂无数据" max-height="600"></Table>

    </Modal>
  </div>
</template>

<script>

import Setting from '@/setting';

export default {
  // 定义组件的属性
  props: {
    // 从父组件接收的属性
    uploadUrl: { // 用于上传文件的URL
      type: String,
      default: Setting.importFileUploadUrl,
    },
    uploadButtonText: { // 上传按钮的文本
      type: String,
      default: '导入',
    },
    importMethod: { // 处理数据和导入数据的回调
      type: Function,
      required: true,
    },
  },
  // 初始化组件的数据
  data() {
    return {
      // 控制导入是否显示
      importModalVisible: false,
      // 预览数据的列定义
      previewColumns: [],
      // 预览数据
      previewData: [],
      // 文件地址
      fileUrl: '',
    };
  },
  // 定义组件的方法
  methods: {
    // 上传文件前的校验
    beforeUpload(file) {
      // 检查文件扩展名是否允许
      const allowedExtensions = ['.xls', '.xlsx', '.csv', '.tsv'];
      const isXLS = file.type.includes('application/vnd.ms-excel');
      const isXLSX = file.type.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');

      if (isXLS || isXLSX) {
        // 文件是 .xls 或 .xlsx 类型
      } else {
        const isAllowedExtension = allowedExtensions.includes(file.name.slice(-4).toLowerCase());
        if (!isAllowedExtension) {
          this.$Message.error('只能上传 .xls, .xlsx, .csv 或 .tsv 文件');
          return false;
        }

        // 对于.csv 和 .tsv 文件，没有特定的 MIME 类型，我们仅依赖扩展名检查
        if (file.name.endsWith('.csv')) {
          // 使用 Papa Parse 或其他 CSV 解析库处理 .csv 文件
        } else if (file.name.endsWith('.tsv')) {
          // 使用适当的库处理 .tsv 文件
        } else {
          this.$Message.error('不支持的文件类型');
          return false;
        }
      }

      return true; // 或者根据校验结果返回true/false
    },
    // 文件上传成功后的处理
    handleSuccess(response, file) {
      if (response.code === 200) {
        this.fileUrl = response.data.file_url;
        // 调用父组件提供的处理预览数据的回调
        this.$emit('importMethod', {file_url: this.fileUrl, preview: 1});
      }else{
        this.$Message.success(response.msg);
        return false;
      }
    },
    // 接收从父组件传递过来的数据
    receiveProcessedData({ header, data }) {
      // 根据header和data更新预览表格
      this.previewColumns = header ? Object.keys(header).map(key => ({ title: key, key: header[key] })) : [];
      this.previewData = data || [];

      // 显示预览
      this.importModalVisible = true;
    },
    // 确认导入的处理
    confirmImport() {
      // 调用父组件提供的确认导入回调
      this.$emit('importMethod', {file_url: this.fileUrl});

      // 关闭预览
      this.importModalVisible = false;
    },
    // 取消导入的处理
    cancelImport() {
      // 关闭预览
      this.importModalVisible = false;
    },
  },
};
</script>
